import API from "./axios";

const expenseMasterApi = {
  paged:     (params = {}) => API.get("/expense-masters/paged", { params }),
  getAll:    ()         => API.get("/expense-masters"),
  getActive: ()         => API.get("/expense-masters/active"),
  getById:   (id)       => API.get(`/expense-masters/${id}`),
  create:    (data)     => API.post("/expense-masters", data),
  update:    (id, data) => API.put(`/expense-masters/${id}`, data),
  toggle:    (id)       => API.patch(`/expense-masters/${id}/toggle-status`),
  delete:    (id)       => API.delete(`/expense-masters/${id}`),
};

export default expenseMasterApi;